import React, { useEffect, useState } from 'react'
import { stringify } from 'querystring'
import classNames from 'classnames'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import fetch from 'lib/decorated-fetch'
interface ICarItem {
  series_id: number
  min_price: number
  max_price: number
  series_name: string
}

export default function CarList({
  series_id,
  className,
}: {
  series_id: number
  className?: string
}) {
  const [carList, setCarList] = useState<ICarItem[]>([])
  useEffect(() => {
    const fetchData = async () => {
      const json = await fetch(
        `/motor/m_api/pc_series_info_in_brand?${stringify({ series_id })}`
      ).catch(e => {
        // no-op
      })
      setCarList(json?.data?.list || [])
    }
    fetchData()
  }, [])

  return carList.length > 0 ? (
    <div className={classNames('container', className)}>
      <div className="title">同品牌车系</div>
      <ul>
        {carList.slice(0, 8).map(carItem => (
          <li key={carItem.series_id}>
            <a
              className="name line-1"
              href={`/auto/series/${carItem.series_id}`}
              // eslint-disable-next-line react/jsx-no-target-blank
              target="_blank"
              onClick={() => {
                sendTeaCommEvent('click_same_brand_series_card', {
                  car_series_id: carItem.series_id,
                })
              }}
            >
              {carItem.series_name}
            </a>
            <a
              className="range"
              href={`/auto/series/${carItem.series_id}`}
              // eslint-disable-next-line react/jsx-no-target-blank
              target="_blank"
            >
              {carItem.min_price}-{carItem.max_price}万
            </a>
          </li>
        ))}
      </ul>
      <style jsx>
        {`
          .container {
            padding: 20px 16px;
            background-color: white;
            width: 320px;
          }
          .title {
            font-size: 18px;
            font-weight: 500;
            color: #1f2129;
          }
          ul {
            margin-top: 24px;
            list-style-type: none;
          }
          li {
            display: flex;
            margin-bottom: 18px;
            align-items: center;
            justify-content: space-between;
            font-size: 14px;
            line-height: 18px;
          }
          li:last-child {
            margin-bottom: 0;
          }
          .name {
            color: #1f2129;
            display: inline-block;
            max-width: 174px;
          }
          .range {
            font-size: 14px;
            font-weight: 500;
            color: #e62021;
          }
        `}
      </style>
    </div>
  ) : null
}
